<script lang="ts">
	import type { Snippet } from 'svelte'
	import { page } from '$app/state'

	interface Props {
		id?: string
		title?: string
		href: string
		children?: Snippet
		class?: string
		onclick?: () => void
	}

	let { id, title, href, children, class: classNames = '', onclick }: Props = $props()
	const activeClasses = $derived(
		href === '/' // Check if this is the Home link
			? page.url.pathname === '/' || page.url.pathname === '' // Matches exactly `/` or empty paths
				? 'tw:bg-lilac tw:text-white'
				: ''
			: page.url.pathname.startsWith(href) // Check partial match for other links
				? 'tw:bg-lilac tw:text-white'
				: ''
	)
</script>

<a
	{id}
	{onclick}
	class="tw:text-sm tw:font-medium tw:hover:bg-lilac tw:hover:text-white tw:no-underline tw:p-2 {classNames} {activeClasses}"
	role="menuitem"
	aria-current="page"
	{href}>
	{#if children}
		{@render children()}
	{:else}
		{title}
	{/if}
</a>
